import React from 'react'
import { Oval } from 'react-loader-spinner'

function Button({ white = false, fullWidth = false, loading = false, children, ...rest }) {
    return (
        <button
            {...rest}
            disabled={loading}
            className={`uppercase ${loading ? 'opacity-90' : 'opacity-100'} px-12 py-4 text-center font-medium flex items-center justify-center gap-2
              text-xs rounded-full ${fullWidth ? 'w-full' : 'w-fit'} transition-all delay-[70] ease-linear
            ${white ? 'bg-white text-black border-black/20 hover:bg-black hover:text-white shadow' :
                    'bg-black text-white border-transparent flex justify-center items-center '}
             `}
        >
            {loading && <Oval width={16} strokeWidth={5} height={16} color='white' secondaryColor='white' />}
            {children}
        </button>
    )
}

export default Button